var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 112.2",
    style: {
      enableBackground: "new 0 0 70 112.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1{fill:#0071BC;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_26_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st0",
    d: "M34.5,106.2c0,0-9.3,0-15.5,0s-7.8,6-7.8,6h23.3V106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st0",
    d: "M35.5,106.2c0,0,9,0,15.2,0s7.8,6,7.8,6h-23V106.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st1",
    d: "M35.5,86.8v21.3H19c0,0-9.6-11.9-3.9-20.9S35.5,86.8,35.5,86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st1",
    d: "M35.5,86.8v21.3h16.3c0,0,9.7-11.9,4-20.9S35.5,86.8,35.5,86.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegs);
export default __webpack_public_path__ + "static/media/legs.f8838758583c630569edfdb05aaeb7a6.svg";
export { ForwardRef as ReactComponent };